import { memo, useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { Box } from '@zillow/constellation-10';
import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

import propertyUtils from '../../../../utils/propertyUtils';

import { useSelector } from '../../../../selectors/useSelector';

import { StyledAddressDetails } from './StyledComponents';

//  TODO: create shared Address model to use here/elsewhere througout the code
type Address = {
  street: string;
  city: string;
  state: string;
  unit: string;
  name?: string;
  zip: string;
};

type Props = {
  address: Address;
};

const AddressDetails = ({ address }: Props): JSX.Element => {
  const { currentProperty } = useSelector(
    (state) => ({
      currentProperty: state.properties.currentProperty,
    }),
    shallowEqual,
  );

  const { formattedStreet, formattedCityStateZip } = useMemo(() => {
    return propertyUtils.formatAddress(
      address || {
        street: currentProperty?.street,
        city: currentProperty?.city,
        state: currentProperty?.state,
        unit: currentProperty?.unit,
        name: currentProperty?.name,
        zip: currentProperty?.zip,
      },
    );
  }, [address]);

  return (
    <StyledAddressDetails data-testid="AddressDetails">
      <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <LoadingHeading
            level={5}
            fontFamily="heading-alt"
            isLoading={Boolean(!formattedStreet)}
            loadingWidth="400px"
            css={{
              fontSize: { base: 'body', lg: 'heading-sm' },
              lineHeight: { base: 'body', lg: 'heading-sm' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: { base: '62vw', mobile390: '50vw', xl: '60vw', xxl: '800px' },
            }}
          >
            {formattedStreet}
          </LoadingHeading>
          <LoadingParagraph
            textStyle="body-sm"
            isLoading={Boolean(!formattedCityStateZip)}
            loadingWidth="400px"
            css={{ color: 'text.subtle', fontSize: { lg: 'body' } }}
          >
            {formattedCityStateZip}
          </LoadingParagraph>
        </Box>
      </Box>
    </StyledAddressDetails>
  );
};

export default memo(AddressDetails);
